<template>
  <!-- <DBox
    :id="'cmp-invoice-lines'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add')} ${$t('invoice_line_string')}`"
    @add_click="onAddInvoiceLine"
  > -->
    <!-- <div class="ut-fc"> -->
    <div class="ut-fc" style="border:1px solid var(--sprt-5);margin-top:20px">
      <div style="height:200px;">
        <NTable
          class="dbox1"
          :headers="headers"
          :items="list"
          :id="'accounting-invoices-invoice_line'"
          :config="tableConfig"
          :showNoItems="false"
        >
          <template v-slot:item="{ item, tdcon }">
            <tr>
              <td v-bind="tdcon('vat_class')">
                <Dropdown2
                  class="dbox1"
                  :showLabel="false"
                  :disabled="false"
                  :options="vatClassTV"
                  :selected="vatClassTV.find(v => v.value == item.vat_class)"
                  :placeholder="$t('vat_class')"
                  v-on:selectedChange="e => onDropdownChange(item, e)"
                  :bb="'0px'"
                
                />
              </td>
              <td v-bind="tdcon('account')">
                <TextField2
                  type="text"
                  :showLabel="false"
                  id="account_no"
                  class="dbox1"
                  :disabled="false"
                  :value="item['account_no']"
                  :bb="'0px'"
                  @change="e => onTextFieldChange(e, item)"
                />
              </td>
              <td v-bind="tdcon('vat_rate')">
                <TextField2
                  id="vat_rate"
                  class="dbox1"
                  :showLabel="false"
                  :disabled="false"
                  :value="item['vat_rate']"
                  :type="'number'"
                  :bb="'0px'"
                  :ta="'right'"
                  @change="e => onTextFieldChange(e, item)"
                />
              </td>
              <td v-bind="tdcon('start_date')">
                    <DatePicker2
                        id="start_date"
                      
                        :showLabel="false"
                        :value="item['start_date']"
                        :bb="'0px'"
                        @input="e=>onTextFieldChange(e,item)"
                    />

              </td>
              <td v-bind="tdcon('end_date')">
                <DatePicker2
                    id="end_date"
                    :showLabel="false"
                    :value="item['end_date']"
                    :bb="'0px'"
                    @input="e=>onTextFieldChange(e,item)"
                />
              </td>
              <td v-bind="tdcon('options')">
                <div style="padding-left: 2px" class="dt-icon-container">
                  <img
                    src="static/icons/delete.svg"
                    class="dt-icon v5 s1"
                    @click="e => onDelete(item)"
                    :alt="$t('delete_vat_rate')"
                    :title="$t('delete_vat_rate')"
                  />
                </div>
              </td>
            </tr>
          </template>
        </NTable>
      </div>
    
      <div>
        <button
          style="margin-top: 10px;margin-bottom: 10px;margin-left: 10px;"
          class="dt-button v3 c5"
          @click="onAddRow"
        >
          + {{$t('add_vat_rates')}}
        </button>
      </div>
    </div>
  <!-- </DBox> -->
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";

import { EventHooks } from "../../../../plugins/text-field";
import { createNTableConfig } from "../../../../plugins/datatable";
import { mapGetters } from "vuex";
import { parseNumber } from "../../../../utility";
import { createTV, tv } from "../../../../models/text-value.model";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { createTableHeader } from "../../../../plugins/datatable";
import { values } from 'ramda';
export default {
  components: {
    NTable,
    DBox
  },
  props: {
 vatTerritoryData:{
      type: Object,
      default: {},
    }
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur
      },

      tableConfig: createNTableConfig({
        fullHeight: true,
        headerStyle: 3
      })
    };
  },
  computed: {
    
    headers: function() {
      return [

        createTableHeader("vat_class"),
        createTableHeader("account", { }),
        createTableHeader("vat_rate", { ta: "right" }),
        createTableHeader("start_date", { }),
        createTableHeader("end_date", { }),
        createTableHeader("options", { text: false, mw: 30 })
      ];
    },

    list:function(){
        return this.vatTerritoryData.vat_rates||[]
    },

    vatClassTV:function(){
        return [
            {text:'No Vat',value:'0'},
            {text:'Statdard Vat',value:'1'},
            {text:'Reduced 1',value:'2'},
            {text:'Reduced 2',value:'3'},
            {text:'Super Reduced',value:'4'},
            {text:'Parking Rate',value:'5'},
        ];
    }
    
  },
  methods: {  
    onDropdownChange: function(item,e) {
      console.log(item,e)

      this.$emit("changed", { name:'vat_class', value:e.value ,kVal:item.vat_rate_id,vat_class_name:e.text });

      // this.$emit("change_tax_deduc", {
      //   name: "tax_type_id_deduction",
      //   value: value.value
      // });
    },
    onDelete: async function(item) {
      /*const confirmationResult = await confirmDelete("Invoice Line");
      if (confirmationResult === "OK") {
        this.$emit("invoiceline_deleted", item);
      }*/
      this.$emit("delete", item);

    },
    onTextFieldChange: function({ name, value }, item) {

      this.$emit("changed", { name, value ,kVal:item.vat_rate_id ,vat_class_name:undefined});
      // if (name == "vat_rate") {
      //   value = (+value).toFixed(2);
      // }
      // this.$emit("changed", {
      //   name,
      //   value,
      //   item
      // });
    },

    onDateUpdate: function(e,item) {
      // console.log(e)
      // const { name ,value }=e
      // this.$emit("changed", { name, value ,kVal:item.vat_rate_id });
    },

    onAddRow:function(){
      this.$emit("add")
    }
    //MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-invoice-lines {
  .dt-ntable {
    // --ntable-height: 170px;

    // --ntable-th-padding: 0px 10px;

    td {
      // padding: 0px;
      input.ntable--textfield {
        margin-left: -10px;
      }
      .dropdown-2 .dropdown {
        min-width: 0px;
      }
    }

    th:nth-child(1),
    td:nth-child(1) {
      // flex: 0.35;
    }
    th:nth-child(6),
    td:nth-child(6) {
      // flex: 0.55;
    }

    td:not(:last-child) {
      // border-right: 1px solid var(--sprt-12);
    }

    th:nth-child(3),
    td:nth-child(3) {
      // flex: 2.5;
    }
    th:nth-child(7),
    td:nth-child(7) {
      // max-width: 30px;
    }
  }
}
</style>
